/* ==========================================================================
   Counter > Prototype
   ========================================================================== */

const tryDisableButton = (element, value, limit) => {
    const button = element;

    if (value === limit) {
        button.disabled = true;
        return true;
    }

    button.disabled = false;
    return false;
};

const increment = function Increment(instance, button) {
    const value = Number(instance.get() + 1);

    if (value <= instance.config.max) {
        instance.set(value);
    }
    tryDisableButton(button, value, instance.config.max);
};

const decrement = function Decrement(instance, button) {
    const value = Number(instance.get() - 1);

    if (value >= instance.config.min) {
        instance.set(value);
    }
    tryDisableButton(button, value, instance.config.min);
};

const counter = {
    hasError: function fn() {
        return this.error;
    },
    setError: function fn() {
        this.error = true;

        this.element.classList.remove(this.config.cssValid);
        this.element.classList.add(this.config.cssError);

        return this;
    },
    setValid: function fn() {
        this.error = false;

        this.element.classList.remove(this.config.cssError);
        this.element.classList.add(this.config.cssValid);

        return this;
    },
    getSpan: function fn() {
        return this.element.querySelector('span');
    },
    get: function fn() {
        if (this.value) return Number(this.value);

        return Number(this.getSpan().textContent);
    },
    getMin: function fn() {
        return this.config.min;
    },
    getMax: function fn() {
        return this.config.max;
    },
    getDefault: function fn() {
        return this.config.default;
    },
    set: function fn(counterValue) {
        const value = Number.isInteger(counterValue) ? Number(counterValue) : Number(this.config.value);

        this.value = value;
        this.getSpan().textContent = value;

        return this;
    },
    setMin: function fn(value) {
        if (value > this.get()) return this;

        this.element.dataset.min = value;
        this.config.min = value;

        return this;
    },
    setMax: function fn(value) {
        this.element.dataset.max = value;
        this.config.max = value;

        return this;
    },
    setDefault: function fn(value) {
        this.element.dataset.default = value;

        return this;
    },
    onChange: function fn(id) {
        if (this.config.onChange.length) this.config.onChange.forEach(item => item.call(this, id));

        return this;
    },
    onClickIncrement: function Fn(event) {
        this.decrementBtn.disabled = false;
        increment(this, event.currentTarget);
        this.onChange(this.id);

        tryDisableButton(this.incrementBtn, this.value, this.config.max);

        /* Prevent bubbling */
        if (this.config.enablePropagation) return;
        event.stopPropagation();
    },
    onClickDecrement: function Fn(event) {
        this.incrementBtn.disabled = false;
        decrement(this, event.currentTarget);
        this.onChange(this.id);

        tryDisableButton(this.decrementBtn, this.value, this.config.min);

        /* Prevent bubbling */
        if (this.config.enablePropagation) return;
        event.stopPropagation();
    },
    bindEvents: function Fn() {
        this.onChange = this.onChange.bind(this);
        this.onClickIncrement = this.onClickIncrement.bind(this);
        this.onClickDecrement = this.onClickDecrement.bind(this);

        return this;
    },
    setButtons: function Fn() {
        this.decrementBtn = this.element.querySelector(`[${this.config.counterDecrement}]`);
        this.incrementBtn = this.element.querySelector(`[${this.config.counterIncrement}]`);

        return this;
    },
    addEventListener: function Fn() {
        /* Bind events */
        this.bindEvents();

        /* Decrement */
        this.decrementBtn.addEventListener('click', this.onClickDecrement);

        /* Increment */
        this.incrementBtn.addEventListener('click', this.onClickIncrement);

        return this;
    },
    removeEventListener: function Fn() {
        /* Decrement */
        this.decrementBtn.removeEventListener('click', this.onClickDecrement);

        /* Increment */
        this.incrementBtn.removeEventListener('click', this.onClickIncrement);

        return this;
    },
    initialize: function fn() {
        /* Set buttons */
        this.setButtons();

        /* Add listeners */
        this.addEventListener();

        /* Init status of buttons */
        tryDisableButton(this.incrementBtn, this.value, this.config.max);
        tryDisableButton(this.decrementBtn, this.value, this.config.min);

        return this;
    }
};

module.exports = counter;
